import styled from 'styled-components';
import theme from '../../styles/theme';
import tinycolor from 'tinycolor2';

export const _Button = styled.a`
  padding: 0.8em 1.6em;
  font-size: 0.9rem;
  background: ${props => props.background};
  color: ${props => props.color};
  border-radius: 5px;
  transition: all 0.3s;
  text-align: center;
  cursor: pointer;
  box-shadow: 0 1px 1px rgba(0,0,0,.2);
  &:hover {
    background: ${props => tinycolor(props.background).lighten(4).toString()};
  }

  ${props => props.block && 'display: block;'};
  ${props => props.width && `width: ${props.width};`};

  ${props => props.popup && `
    box-shadow: 0 1px 0 1px ${tinycolor(props.background).darken(20).toString()}, inset 0 2px 1px rgba(255,255,255,0.4);
    &:hover {
      box-shadow: 0 4px 0 1px ${tinycolor(props.background).darken(20).toString()}, inset 0 2px 1px rgba(255,255,255,0.4);
      transform: translate3d(0, -3px, 0);
    }
  `}
  ${props => props.unstyled && `
    border: none;
    box-shadow: none;
    background: none;
    color: #43463f;
    &:hover {
      background: none;
      color: ${tinycolor('#43463f').lighten(10).toString()};
    }
  `}
`

_Button.defaultProps = {
  background: theme.primary,
  color: theme.light,
}


// WEBPACK FOOTER //
// ./src/components/common/styled-buttons.js